import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { SharedModule } from 'src/app/shared/shared.module';
import { SideNavComponent } from './side-nav.component';

@NgModule({
  imports: [CommonModule, IonicModule, RouterModule, SharedModule],
  declarations: [SideNavComponent],
  exports: [SideNavComponent]
})
export class SideNavModule {}
